import React, { useState } from "react";
import "./ButtonGroup.scss"; // Make sure to add the CSS file for styles
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { icAsset } from "../../../components/image/image-src";
interface ButtonGroupProps {
  onCancel?: () => void;
  onUpgrade?: () => void;
  checkUpdate: boolean;
  checkCancel: boolean;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  onCancel,
  onUpgrade,
  checkUpdate,
  checkCancel,
}) => {
  const [isPopupUpdateVisible, setPopupUpdateVisible] = useState(false);
  const [isPopupCancelVisible, setPopupCancelVisible] = useState(false);
  const [popupType, setPopupType] = useState<string | null>(null);
  const { t } = useTranslation();
  const handleUpgradeClick = () => {
    if (checkUpdate) {
      setPopupType("update");
    } else {
      setPopupType("update-fail");
    }
    if (onUpgrade) {
      onUpgrade();
    }
  };

  const handleCancelClick = () => {
    if (checkCancel) {
      setPopupType("cancel");
    } else {
      setPopupType("cancel-fail");
    }
    if (onCancel) {
      onCancel();
    }
  };

  const closePopup = () => {
    setPopupType(null); // Close the popup
  };

  return (
    <div>
      {/* The Button Group */}
      <div className="flex justify-end space-x-4">
        <button
          className="h-[3.125rem] w-[11.25rem] rounded-[3.125rem] border border-[#000000] bg-white text-base font-normal text-[#232323]"
          onClick={handleCancelClick}
        >
          {t("Cancel")}
        </button>
        <button
          className="h-[3.125rem] w-[11.25rem] rounded-[3.125rem] bg-primary text-base font-normal text-[#232323]"
          onClick={handleUpgradeClick}
        >
          {t("Upgrade")}
        </button>
      </div>

      {/* Popup (modal) Update */}
      {popupType === "update" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="popup-modal w-[22.5rem] gap-[1.5rem] rounded-[1.25rem] bg-white p-[2rem]">
            <div className="text-center">
              <div className="mb-4 flex justify-center">
                <img
                  src={icAsset("../../../assets/icons/question.svg")}
                  className="h-[3rem] w-[3rem] rounded-[0.5rem] object-cover"
                  alt="question icon"
                />
              </div>
              <p className="mb-6 text-lg">
                {t("This note was written by admin")}
              </p>
              <div className="flex justify-between space-x-4">
                <button
                  className="h-[3rem] w-[18.5rem] rounded-[3.125rem] bg-[#E9EAEB] text-base font-normal text-[#232323]"
                  onClick={closePopup}
                >
                  {t("No")}
                </button>
                <button
                  className="h-[3rem] w-[18.5rem] rounded-[3.125rem] bg-primary text-base font-normal text-[#232323]"
                  onClick={closePopup}
                >
                  {t("Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Fallback Popup (modal) Update - When checkUpdate is false */}
      {popupType === "update-fail" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="popup-modal w-[22.5rem] gap-[1.5rem] rounded-[1.25rem] bg-white p-[2rem]">
            <div className="text-center">
              <div className="mb-4 flex justify-center">
                <img
                  src={icAsset("../../../assets/icons/warning.svg")}
                  className="h-[3rem] w-[3rem] rounded-[0.5rem] object-cover"
                  alt="warning icon"
                />
              </div>
              <p className="mb-6 text-lg">
                {t(
                  "This product does not support upgrade. Please contact the admin for more details.",
                )}
              </p>
              <div className="flex justify-between space-x-4">
                <button
                  className="h-[3rem] w-[18.5rem] rounded-[3.125rem] bg-[#E9EAEB] text-base font-normal text-[#232323]"
                  onClick={closePopup}
                >
                  {t("Cancel")}
                </button>
                <Link
                  to={"kakao"}
                  className="flex h-[3rem] w-[18.5rem] items-center justify-center rounded-[3.125rem] bg-primary text-base font-normal text-[#232323]"
                >
                  {t("Chat")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Popup (modal) Cancel */}
      {popupType === "cancel" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="popup-modal w-[22.5rem] gap-[1.5rem] rounded-[1.25rem] bg-white p-[2rem]">
            <div className="text-center">
              <div className="mb-4 flex justify-center">
                <img
                  src={icAsset("../../../assets/icons/question.svg")}
                  className="h-[3rem] w-[3rem] rounded-[0.5rem] object-cover"
                  alt="question icon"
                />
              </div>
              <p className="mb-6 text-lg">
                {t("This note was written by admin")}
              </p>
              <div className="flex justify-between space-x-4">
                <button
                  className="h-[3rem] w-[18.5rem] rounded-[3.125rem] bg-[#E9EAEB] text-base font-normal text-[#232323]"
                  onClick={closePopup}
                >
                  {t("Cancel")}
                </button>
                <button
                  className="h-[3rem] w-[18.5rem] rounded-[3.125rem] bg-primary text-base font-normal text-[#232323]"
                  onClick={closePopup}
                >
                  {t("Confirm")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Fallback Popup (modal) Cancel - When checkCancel is false */}
      {popupType === "cancel-fail" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="popup-modal w-[22.5rem] gap-[1.5rem] rounded-[1.25rem] bg-white p-[2rem]">
            <div className="text-center">
              <div className="mb-4 flex justify-center">
                <img
                  src={icAsset("../../../assets/icons/warning.svg")}
                  className="h-[3rem] w-[3rem] rounded-[0.5rem] object-cover"
                  alt="warning icon"
                />
              </div>
              <p className="mb-6 text-lg">
                {t(
                  "This product does not support refunds. Please contact the admin for more details.",
                )}
              </p>
              <div className="flex justify-between space-x-4">
                <button
                  className="h-[3rem] w-[18.5rem] rounded-[3.125rem] bg-[#E9EAEB] text-base font-normal text-[#232323]"
                  onClick={closePopup}
                >
                  {t("Cancel")}
                </button>
                <Link
                  to={"kakao"}
                  className="flex h-[3rem] w-[18.5rem] items-center justify-center rounded-[3.125rem] bg-primary text-base font-normal text-[#232323]"
                >
                  {t("Chat")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ButtonGroup;
